import moment from 'moment';
import {isEmpty, isString} from 'lodash';
import { ReactComponent as WordFile } from 'assets/icons/word_icon.gov.svg';
import { ReactComponent as PdfFile } from 'assets/icons/pdf_icon.gov.svg';
import { ReactComponent as ExcelFile } from 'assets/icons/excel_icon.gov.svg';
import { ReactComponent as ImageFile } from 'assets/icons/image_icon.gov.svg';
import { ReactComponent as ZipFile } from 'assets/icons/zip_icon.gov.svg';

export const printInfo = (info) => {
    if (typeof info === "undefined" || info === null || info.length === 0) {
      return "-";
    } else {
      return info;
    }
  };

  export const printInfoRanges = (from,to) => {
    return from+' Από '+to;
  };

  export const getFullDateTimeWithSeconds = (date) => {
    if (date == null) {
      return "-";
    } else {
      //console.log(date);
      const dt = Date.parse(date);
      if (isNaN(dt)) return "-";
      else return moment(dt).local().format("DD/MM/YYYY HH:mm:ss");
    }
  };

  export const getJustDate = (date) => {
    if (date == null) {
      return "-";
    } else {
      //console.log(date);
      const dt = Date.parse(date);
      if (isNaN(dt)) return "-";
      else return moment(dt).local().format("DD/MM/YYYY");
    }
  };

  export const formatBytes = (bytes,decimals=2) =>{
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const getFileImage = (type) => {

  switch(type){
      case "word":
           return <WordFile/>;
      case "pdf":
           return <PdfFile/>;
      case "excel":
           return <ExcelFile/>;
      case "image":
           return <ImageFile/>;
      case "content":
              return <ExcelFile/>;  
      default:
           return "";                     
  }

};

export const getFullDateHours = (date) => {

  if(typeof date ==="undefined" || date == null || date.length == 0){
      return "-";
  }
  else{
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
  }
};

//parse a date into moment using accepted formats and validate it
export const validMomentFormat = (value, validFormats) => {
  // console.debug({value})
  if (value && isString(value)) {
    const parsed = moment(value, validFormats, true);
    if (!parsed.isValid()) {
      console.error('Invalid date:', value);
      return null;
    }
    console.debug({parsed})
    return parsed;
  }
  const val = value;
  // console.debug({val});
  return val;
}

//basic extraction of value from an onChange event based on field type. add types as needed.
export const extractValueFromEvent = (type, event) => {
  let newValue;
  console.log(newValue);
  if (type === 'text' || type === 'textarea' || type === 'radio') {
    newValue = event.target.value;
  } else if (type === 'date') {
    newValue = new Date(event).toLocaleDateString('en-US');
  } else if (type === 'checkbox') {
    newValue = event.target.checked;
  } else if (
    type === 'select' ||
    type === 'number' ||
    type === 'numberWithDecimals'
  ) {
    newValue = event;
  }

  return newValue;
}

// Function for custom rounding - rounds down for 3rd decimal < 6, rounds up for >= 6
export function customRound(num, decimalPlaces) {
  // Handle NaN and undefined
  if (isNaN(num) || num === undefined) return 0;
  
  // Convert to string to handle precision better
  const strValue = num.toString();
  
  // Find decimal point position if any
  const decimalPos = strValue.indexOf('.');
  if (decimalPos === -1) return num; // No decimal point
  
  // Get the digit position we care about (decimalPos + decimalPlaces + 1)
  const relevantPos = decimalPos + decimalPlaces + 1;
  
  // If the number doesn't have enough digits after decimal, just return it
  if (relevantPos >= strValue.length) return num;
  
  // Get the digit we need to check for rounding decision
  const checkDigit = parseInt(strValue.charAt(relevantPos), 10);
  
  // Round based on our 6+ rule
  if (checkDigit >= 6) {
    // Round up to the specified decimal places
    return Math.ceil(num * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
  } else {
    // Round down to the specified decimal places
    return Math.floor(num * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
  }
}

// Function for formatting numbers with 2 decimal places and euro symbol
// Using custom rounding rule (round down for 3rd decimal < 6, round up for >= 6)
export const formatCurrency = (value) => {
  if (!value) return '';
  
  // Convert to number if it's a string without euro symbol and European format
  if (typeof value === 'string') {
    // Remove € symbol
    let numericValue = value.replace(/€/g, '');
    
    // Convert European format to JS format
    numericValue = numericValue.replace(/\./g, '').replace(/,/g, '.');
    
    // Parse to float
    const parsedValue = parseFloat(numericValue);
    if (!isNaN(parsedValue)) {
      // If successfully parsed, use the numeric version
      value = parsedValue;
    }
  }
  
  // Now handle the value as a number
  if (typeof value === 'number') {
    // Apply custom rounding
    const rounded = customRound(value, 2);
    
    // Format as European number with thousand separator dots and comma decimal separator
    const parts = rounded.toFixed(2).split('.');
    let integerPart = parts[0];
    const decimalPart = parts[1];
    
    // Add thousand separators
    let formattedInteger = '';
    for (let i = 0; i < integerPart.length; i++) {
      if (i > 0 && (integerPart.length - i) % 3 === 0) {
        formattedInteger += '.';
      }
      formattedInteger += integerPart[i];
    }
    
    return `${formattedInteger},${decimalPart}€`;
  }
  
  // For anything else, return as is
  return value.toString();
};

// Helper function to convert currency text to number
export const parseCurrency = (value) => {
  if (!value) return 0;
  
  // Remove € symbol
  let normalized = value.toString().replace(/€/g, '');
  
  // Convert European number format to standard JavaScript format
  // Replace dots (thousand separators) with nothing and commas with dots
  normalized = normalized.replace(/\./g, '').replace(/,/g, '.');
  
  // Parse to float
  const parsedValue = parseFloat(normalized);
  
  // Return 0 if parsing failed
  return isNaN(parsedValue) ? 0 : parsedValue;
};


